import React, { useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import { useHookstate } from '@hookstate/core';
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState";
import { useLanguageState } from '../../globalStates/LanguageState';
import FilePicker from "../../components/FilePicker";
import Section from "../../components/Section";

const MobileHeaderImageSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()
    const organizationState = exiState.getOrganization()
    const organization = useHookstate(organizationState)

    const onChangeHeaderImage = useCallback((image: File, onUploadProgress, onSuccessCallback, onErrorCallback) => {
        exiState.upload("BACKGROUND_MOBILE", image, onUploadProgress)
            .then(response => {
                onSuccessCallback();
                if (response) {
                    organization.backgroundImageMobileFileId.set(response.fileId)
                    organization.backgroundImageMobileUrl.set(response.fileUrl)
                }
            })
            .catch(reason => onErrorCallback(reason))
    }, [exiState, organization])

    const onRemoveHeaderImage = useCallback(() => {
        organization.backgroundImageMobileFileId.set('')
        organization.backgroundImageMobileUrl.set('')
    }, [organization])

    return (
        <Section title={branding.configuration.profilePage.sctMobileHeaderImageUpload.lblUpload}>
            <Row>
                <Col>
                    <FilePicker
                        name="headerImage"
                        label={branding.configuration.profilePage.sctMobileHeaderImageUpload.lblHeaderImage}
                        placeholderTitle={branding.configuration.profilePage.sctMobileHeaderImageUpload.hntTitleHeaderImage}
                        placeholderText={branding.configuration.profilePage.sctMobileHeaderImageUpload.hntPropHeaderImage}
                        browseLabel={branding.configuration.profilePage.sctMobileHeaderImageUpload.btnBrowseFilesHeaderInage}
                        deleteLabel={branding.configuration.profilePage.sctMobileHeaderImageUpload.btnDeleteImgHeader}
                        value={organization.backgroundImageMobileUrl.get()}
                        onChangeImage={onChangeHeaderImage}
                        onRemoveImage={onRemoveHeaderImage}
                    />
                </Col>
            </Row>

        </Section>
    )
}

export default MobileHeaderImageSection
